import { motion } from "motion/react";
import type { ReactNode } from "react";
import { twJoin } from "tailwind-merge";

import { Spinner } from "./Spinner";

export function FullSizeLoader({
  size = "md",
  withPadding,
  noDelay = false,
}: {
  size?: "sm" | "md";
  withPadding?: boolean;
  noDelay?: boolean;
}): ReactNode {
  return (
    <motion.div
      className={twJoin("flex size-full items-center justify-center", withPadding && "py-space-md")}
      initial={{ opacity: noDelay ? 1 : 0 }}
      animate={{ opacity: 1 }}
      transition={noDelay ? undefined : { delay: 0.4 }}
      data-testid="full-size-loader"
    >
      <Spinner size={size === "sm" ? "xl" : "3xl"} />
    </motion.div>
  );
}
